import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

declare global {
  interface Window {
    clarity: any;
  }
}

@Injectable({
  providedIn: "root",
})
export class ClarityService {
  private isLoaded = false;

  constructor() {}

  loadClarity(): void {
    if (this.isLoaded) return;

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.innerHTML = `
      (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "${environment.clarityId}");
    `;
    document.head.appendChild(script);
    this.isLoaded = true;
  }

  setUserType(role: string): void {
    window.clarity('set', 'userRole', role);
  }
}